import { FormValidations } from "features/shared/forms/hooks/useForm";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";
import ValidationService from "features/validation/ValidationService";

export const emailFormValidations = (): FormValidations => {
  return {
    DESC_TMEMAILPUVODVyBER: {
      required: true,
      type: "OnlyRequired"
    },
    DESC_TMEMAIL: {
      required: true,
      type: "Function",
      validate: (value: any) => new ValidationService().ValidateEmail(value),
      message: "invalidEmail"
    } as FunctionValidationRule
  };
}